<template>
  <div class="is-relative is-height-100p">
    <div class="pa-20 is-height-100p is-overflow-y-active" v-if="pointDeVenteRecommandation">
      <societe-selector></societe-selector>
      <recom-label
        v-if="isEditRecom"
        :recommandation="recommandation"
        classLabel="is-size-6 has-text-grid-1 has-text-weight-bold"
        showLabel>
      </recom-label>
      <div class="card">
        <header class="card-header">
          <div class="card-header-title is-paddingless">
            <article class="media media-align-center">
              <figure class="media-left" >
                <p class="image is-58x58">
                  <img :src="func.getImg(pointDeVenteRecommandation.srcImg)">
                </p>
              </figure>
              <div class="media-content">
                <div class="content">
                  <p class="is-size-14px has-text-weight-bold has-text-gird-1">
                    {{ pointDeVenteRecommandation.nomCommercial }}
                  </p>
                </div>
              </div>
            </article>
          </div>
          <div class="card-header-icon mr-10" @click="modifPDV()">
            <img src="@/assets/images/icon/circle-edit-outline.png">
          </div>
        </header>
      </div>
      <div class="columns is-marginless">
        <div class="column is-4">
          <b-field custom-class="mb-4px">
            <template slot="label">
              <qd-label :label="$t('listePanneau.montantHonoraireForfaitaire')" />
            </template>
            <input-currency v-model="montantHonoraireForfaitaire"/>
          </b-field>
        </div>
        <div class="column is-4">
          <b-field custom-class="mg-4px mb-4px">
            <template slot="label">
              <qd-label :label="$t('listePanneau.assistant')" />
            </template>
            <b-select
              :value="assistant"
              @input="setAssistantId"
              :placeholder="$t('listePanneau.assistant')"
              expanded>
              <option>
              </option>
              <option
                v-for="user in assistantsCommerciaux"
                :key="user.id"
                :value="user.id">
                {{ user.nom }} {{ user.prenom }}
              </option>
            </b-select>
          </b-field>
        </div>
      </div>
      <b-tabs class="mt-20" v-model="activeTabPanneau" multiline>
        <b-tab-item
          :label="$t('listePanneau.ongletPanneau', {nbre: this.panneauxActif.length })"
          icon="sign-text">
          <div class="level mb-20">
            <div class="level-left mb-10 has-text-weight-bold is-size-14px has-text-gird-1">
              {{`${this.panneauxActif.length} ${$t('listePanneau.labelNbrPanneau')}`}}
            </div>
            <div class="level-right">
              <b-button
                type="is-primary"
                class="has-text-weight-bold border-radius-right-none"
                @click="$router.push({ name: 'creer-panneau' })">
                {{ $t('listePanneau.libelleBtnCreerPanneau') }}
              </b-button>
              <b-dropdown aria-role="list" position="is-bottom-left">
                <template #trigger="{ active }">
                  <b-button type="is-primary" class="border-radius-left-none" :icon-right="active ? 'menu-up' : 'menu-down'" />
                </template>
                <b-dropdown-item
                  aria-role="listitem"
                  @click="modalAddPanels = true">
                  {{ $t('listePanneau.libelleBtnAddExistPanel') }}
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
          <cardPanneau
            v-for="panneau in panneauxActif"
            :key="panneau.guid"
            :panneau="panneau"
            type='new'
            @click-card="actionPanneau(panneau)"
            @click-button="deletePanneau(panneau)"/>
        </b-tab-item>
        <b-tab-item
          :label="$t('listePanneau.ongletEncours', {nbre: this.panneauxSousContrat.length })"
          icon="tooltip">
          <div class="level mb-20">
            <div class="level-left mb-10 has-text-weight-bold is-size-14px has-text-gird-1">
              {{`${this.panneauxSousContrat.length} ${$t('listePanneau.labelNbrPanneauEncours')}`}}
            </div>
          </div>
          <cardPanneau
            v-for="(panneau, index) in panneauxSousContrat"
            :key="index + 'Old'" :panneau="panneau" type='old'
            @click-card="actionPanneau(panneau, 'view')"
            @click-button="deletePanneau(panneau)"/>
        </b-tab-item>
        <b-tab-item
          :label="$t('listePanneau.ongletInactifs', {nbre: this.panneauxInactif.length })"
          icon="cancel">
          <div class="level mb-20">
            <div class="level-left mb-10 has-text-weight-bold is-size-14px has-text-gird-1">
              {{`${this.panneauxInactif.length} ${$t('listePanneau.labelNbrPanneauInactifs')}`}}
            </div>
          </div>
          <cardPanneau
            v-for="panneau in panneauxInactif"
            :key="panneau.guid"
            :panneau="panneau"
            type='inactif'
            @click-button="actionDeleteOrRestorPanneau(panneau)"
            @click-card="actionPanneau(panneau, 'view')"/>
        </b-tab-item>
        <b-tab-item
          :label="$t('listePanneau.ongletsConcurrents', {nbre: this.getNbreConcurrents })"
          icon="flag">
          <div class="level mb-20">
            <div class="level-left mb-10 has-text-weight-bold is-size-14px has-text-gird-1">
              {{ $t('listePanneau.labelNbrConcurrents', {nbre: this.getNbreConcurrents }) }}
            </div>
            <div class="level-right">
              <b-button
                type="is-primary"
                class="has-text-weight-bold"
                @click="ajouterConcurrent()">
                {{$t('general.btnAjouter')}}
              </b-button>
            </div>
          </div>
          <concurrent></concurrent>
        </b-tab-item>
      </b-tabs>
    </div>
    <div v-else class="section">
      <div class="content has-text-grid-1 has-text-centered">
        <p class="is-size-7">
          {{$t('tableauDeBord.listeRecom.empty')}}
        </p>
      </div>
    </div>
    <modal-confirm
      :modal-is-active="modalIsActive"
      :message="$t('listePanneau.modalConfirmation.message')"
      :info-message="$t('listePanneau.modalConfirmation.infoMessage')"
      :libelle-btn-valide="$t('listePanneau.modalConfirmation.libelleBtnValide')"
      :libelle-btn-cancel="$t('general.btnAnnuler')"
      @modalIsClose="modalIsActive = $event"
      @isValide="actionDeleteOrRestorPanneau(panneauSelected), modalIsActive = false"
      type="is-confirmation"/>
    <b-modal
      v-model="modalAddPanels"
      :width="1440"
      has-modal-card>
      <ModalListProduit />
    </b-modal>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as types from '@/store/modules/recommandations-mutation-type';
import Modal from '@/components/general/modal.vue';
import CardPanneau from '@/components/general/cardPanneau.vue';
import Concurrent from '@/components/recommandation/concurrent/concurrent';
import {
  SET_FILTER_RAYON,
  SET_ADRESSE_POINT_CENTRAL,
  SET_AFFICHER_MARKER_PDV
} from '@/store/creationRecommandation/pointDeVente-mutation-type';
import { RAYON_DEFAULT } from '@/configuration/configurationCarte';
import SocieteSelector from '@/components/general/societeSelector';
import RecomLabel from '@/components/recommandation/recomLabel';
import { getImg } from '@/services/general/general';
import gestionErreur from '@/services/general/gestionErreur';
import ModalListProduit from '@/components/recommandation/creerPanneau/modalListProduit.vue';
import InputCurrency from '@/components/general/inputCurrency.vue';
import QdLabel from '@/components/general/qdLabel.vue';
import { PARAMETRES_KEYS } from '@/store/modules/parametrage-mutation-type';

const Recommandations = createNamespacedHelpers('recommandations');
const PointDeVente = createNamespacedHelpers('pointDeVente');
const Parametres = createNamespacedHelpers('parametrage');

export default {
  data() {
    return {
      modalIsActive: false,
      modalAddPanels: false,
      panneauSelected: null,
      func: { getImg },
    };
  },
  components: {
    modalConfirm: Modal,
    CardPanneau,
    Concurrent,
    SocieteSelector,
    RecomLabel,
    ModalListProduit,
    InputCurrency,
    QdLabel,
  },
  computed: {
    ...Recommandations.mapGetters({
      panneaux: 'panneaux',
      pointDeVenteRecommandation: 'pointDeVente',
      activeTabListePanneau: 'activeTabListePanneau',
			honoraireForfaitaire: 'honoraireForfaitaire',
      assistant: 'assistant',
      recommandation: 'recommandation',
    }),
    ...PointDeVente.mapGetters({
      getNbreConcurrents: 'nbreConcurrents',
    }),
    ...Parametres.mapGetters({
      parametre: 'parametre',
    }),
    isEditRecom() {
      return !!this.recommandation && !!this.recommandation.id;
    },
    panneauxActif() {
      if (!this.panneaux.length) return [];
      return this.panneaux.filter(el => el.actif && !el.estPanneauSousContrat);
    },
    panneauxInactif() {
      if (!this.panneaux.length) return [];
      return this.panneaux.filter(el => !el.actif);
    },
    panneauxSousContrat() {
      if (!this.panneaux.length) return [];
      return this.panneaux.filter(el => el.actif && el.estPanneauSousContrat);
    },
    activeTabPanneau: {
      get() {
        return this.activeTabListePanneau;
      },
      set(value) {
        this.setActiveTab(value);
      },
    },
		montantHonoraireForfaitaire: {
			get() {
				return this.honoraireForfaitaire;
			},
			set(value) {
				this.setHonoraireForfaitaire(value);
			},
		},
    users() {
      return this.parametre(PARAMETRES_KEYS.utilisateur);
    },
    assistantsCommerciaux() {
      return (this.users || []).filter(u => u.profil === 'AssistantCommercial');
    },
  },
  methods: {
    ...Recommandations.mapMutations({
      actionsSetPdv: types.SET_POINT_DE_VENTE,
      actionDeleteOrRestorPanneau: types.DELETE_RESTOR_PANNEAU,
      setActiveTab: types.SET_ACTIVE_TAB,
      setAssistantId: types.SET_ASSISTANT_ID,
      loadProduitsLocation: 'loadProduitsLocation',
    }),
    ...Recommandations.mapActions({
      loadProduitsLocationForce: 'loadProduitsLocationForce',
      loadPanneauxSousContrat: 'loadPanneauxSousContrat',
      setHonoraireForfaitaire: 'setLigneHonoraireForfaitaire',
    }),
    ...PointDeVente.mapMutations({
      setFilterRayon: SET_FILTER_RAYON,
      setAdressePointCentral: SET_ADRESSE_POINT_CENTRAL,
      setAfficherMarkerPdv: SET_AFFICHER_MARKER_PDV,
    }),
    deletePanneau(panneau) {
      this.panneauSelected = panneau;
      this.modalIsActive = true;
    },
    modifPDV() {
      this.$router.push({ name: 'modifier-point-de-vente' });
    },
    actionPanneau(panneau, action) {
      this.$router.push({
        name: action === 'view' ? 'view-panneau' : 'modifier-panneau',
        params: { guid: panneau.guid },
      });
    },
    ajouterConcurrent() {
      this.setFilterRayon(RAYON_DEFAULT);
      this.setAdressePointCentral(this.pointDeVenteRecommandation.adressePostale);
      this.setAfficherMarkerPdv(true);
      this.$router.push({ name: 'recherche-concurrent' });
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.loadProduitsLocationForce();
      await this.loadPanneauxSousContrat();
    } catch (error) {
      gestionErreur('Erreur lors de la récupération des panneaux sous contrat du point de vente', this.pointDeVenteRecommandation.id);
      throw error;
    } finally {
      loadingComponent.close();
    }
  }
};
</script>
